import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Contacts, Env, PendingContacts } from '@usimweb/core/models';
import { DialogService } from '@usimweb/ui/dialogs';
import { InfoDialogComponent } from '@usimweb/ui/dialogs';

import { Store } from '@ngrx/store';
import { Observable, take } from 'rxjs';
import * as fromStore from '@usimweb/state/store';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-inv-confirmation',
    templateUrl: './inv-confirmation.component.html',
    styleUrls: ['./inv-confirmation.component.scss'],
    standalone: false
})
export class InvConfirmationComponent implements OnInit {
  private requestId: number = 0;

  public contacts$!: Observable<PendingContacts>;
  public mainColor = '';

  constructor(
    @Inject('environment') environment: Env,
    private store: Store<fromStore.DashboardState>,
    private route: ActivatedRoute,
    private router: Router,
    private dialogService: DialogService,
    private snackBar: MatSnackBar
  ) {
    this.mainColor = environment.mainColor;
  }

  ngOnInit(): void {
    this.requestId = parseInt(this.route.snapshot.paramMap.get('id') || '0');
    this.contacts$ = this.store.select(fromStore.getInvitesById(this.requestId));
  }

  public permit() {
    this.dialogService
      .openTextDialog(
        InfoDialogComponent,
        undefined,
        'Permit sharing request',
        'Yes',
        'Are you sure you want to permit the sharing request?'
      )
      .subscribe((data) => {
        if (data) {
          this.snackBar.open('Contact request permitted...', 'OK', { duration: 2000 });
          this.store.dispatch(new fromStore.AcceptInvite(this.requestId));
          this.router.navigate(['app/projects']);
        }
      });
  }

  public deny() {
    this.dialogService
      .openTextDialog(
        InfoDialogComponent,
        undefined,
        'Deny sharing request',
        'Yes',
        'Are you sure you want to deny the sharing request?'
      )
      .subscribe((data) => {
        if (data) {
          this.snackBar.open('Contact request denied...', 'OK', { duration: 2000 });
          this.store.dispatch(new fromStore.RejectInvite(this.requestId));
          this.router.navigate(['app/projects']);
        }
      });
  }
}
